import { Record } from "immutable";


export class SeatingChart extends Record({
    id: 0,
    original_background: "",
    background: "",
    width: 0,
    height: 0
}) {}

export class Block extends Record({
    id: 0,
    name: ""
}) {}

export class Row extends Record({
    id: 0,
    block: new Block(),
    name: ""
}) {}

export class Seat extends Record({
    id: 0,
    name: "",
    x: 0,
    y: 0,
    row: null as Row|null,
    category: null as Category|null,
    deletable: true
}) {}

export class Category extends Record({
    id: 0,
    name: "",
    color: "#000000"
}) {}

export enum AnchorType {
    CUSTOM = 0,

    TOP_LEFT = 1,
    TOP_CENTER = 2,
    TOP_RIGHT = 3,

    MIDDLE_LEFT = 4,
    MIDDLE_CENTER = 5,
    MIDDLE_RIGHT = 6,

    BOTTOM_LEFT = 7,
    BOTTOM_CENTER = 8,
    BOTTOM_RIGHT = 9,
}
export enum FocusType {
    PUSH,
    PULL
}
export class FocusPoint extends Record({
    anchorType: AnchorType.MIDDLE_CENTER,
    focusType: FocusType.PULL,
    x: null as number|null,
    y: null as number|null,
}) {

    position(width: number, height: number): {x: number, y: number} {
        if (this.anchorType === AnchorType.CUSTOM) {
            return {x: this.x || 0, y: this.y || 0}
        }

        let newX;
        let newY;

        switch (this.anchorType) {
            case AnchorType.TOP_LEFT:
            case AnchorType.TOP_CENTER:
            case AnchorType.TOP_RIGHT:
                newY = 0;
                break;

            case AnchorType.BOTTOM_LEFT:
            case AnchorType.BOTTOM_CENTER:
            case AnchorType.BOTTOM_RIGHT:
                newY = height;
                break;

            case AnchorType.MIDDLE_LEFT:
            case AnchorType.MIDDLE_CENTER:
            case AnchorType.MIDDLE_RIGHT:
                newY = height / 2;
                break;
        }

        switch (this.anchorType) {
            case AnchorType.TOP_LEFT:
            case AnchorType.MIDDLE_LEFT:
            case AnchorType.BOTTOM_LEFT:
                newX = 0;
                break;

            case AnchorType.TOP_CENTER:
            case AnchorType.MIDDLE_CENTER:
            case AnchorType.BOTTOM_CENTER:
                newX = width / 2;
                break;

            case AnchorType.TOP_RIGHT:
            case AnchorType.MIDDLE_RIGHT:
            case AnchorType.BOTTOM_RIGHT:
                newX = width;
                break;

        }

        return {x: newX, y: newY}
    }

}


let cId = 0;
export function newID() : number {
    return -(++cId);
}

export function orderSeats(a: {id: number}, b: {id: number}) : number {
    const aId = a.id;
    const bId = b.id;

    if (aId < 0 && bId < 0) return bId - aId;
    if (aId < 0 && bId >= 0) return -1;
    if (aId >= 0 && bId < 0) return  1;
    if (aId >= 0 && bId >= 0) return aId - bId;

    return 0;
}


export function chainOrder<T>(
    ...sorters: ((a: T, b: T) => number)[]
): (a: T, b: T) => number {
    return (a, b) => {
        for (let sorter of sorters) {
            const result = sorter(a, b);
            if (result !== 0) return result;
        }
        return 0;
    }
}

export const naturalOrder = chainOrder<{name: string, id: number}>(
    (a, b) => {
        const aU = a === null || a === undefined;
        const bU = b === null || b === undefined;

        if (aU === bU) return 0;
        if (aU) return 1;
        if (bU) return -1;

        throw new Error("Unreachable.");
    },
    (a, b) => {
        const aU = a === null || a === undefined;
        const bU = b === null || b === undefined;
        if (aU || bU) return 0;

        if (isNaN(a.name as any) || isNaN(b.name as any)) return 0;
        return Number(a.name) - Number(b.name);
    },
    (a, b) => (b?.name === undefined || b?.name === undefined) ? 1 : (a?.name?.localeCompare(b?.name) || 0),
    (a, b) => orderSeats(a, b)
);
